// / --- components/FAQPage.tsx ---

"use client";
import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../ui/accordion";
import Link from "next/link";
const Faq: React.FC = () => {
  // Consolidate all FAQ data into a single array since categories are removed
  const allFaqData = [
    {
      question: "What industries does Samsan Inc. serve?",
      answer:
        "We specialize in supplying top-tier equipment and solutions for industries including Oil & Gas, Flow Control, Process Equipment, Instrumentation, Electrical and Mechanical Systems, Heavy Construction, Firefighting Safety, and General Order Supplies.",
    },
    {
      question: "What kind of products do you offer?",
      answer:
        "Our inventory includes flow control valves, electrical panels, instrumentation tools, mechanical components, electromechanical assemblies, fire safety gear, and a wide range of industrial supplies needed for complex operational environments.",
    },
    {
      question: "Do you work with well-known industrial brands?",
      answer:
        "Yes. We partner with globally recognized brands. These will be featured across the website using interactive logo carousels and categorized grids to help clients identify trusted solutions.",
    },
    {
      question: "Can I request a custom quote or specific product?",
      answer:
        "Absolutely. You can send your requirements, or reach out via phone or email. Our team will respond promptly with tailored solutions.",
    },
    {
      question: "Are your products compliant with international standards?",
      answer:
        "Yes. Samsan Inc. only supplies certified and industry-standard compliant products. We work with ISO and other standard-compliant brands and manufacturers.",
    },
    {
      question: "Do you support large-scale or urgent industrial projects?",
      answer:
        "Yes. We are equipped to handle bulk orders and urgent supply requests, particularly for critical infrastructure projects in energy, construction, and manufacturing sectors.",
    },
    {
      question: "How can I contact your team?",
      answer:
        "Visit our Contact Page for our phone number, email address, address, and embedded location map. You can also email us at ihsan@samsaninc.com for direct assistance.",
    },
    {
      question:
        "Where are you located, and do you ship nationally/internationally?",
      answer:
        "Samsan Inc. is headquartered in Markham ,Canada. We supply across the country and to select international regions, depending on project scope and compliance requirements.",
    },
  ];

  return (
    <section className="bg-white text-gray-900 py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-tight mb-4">
            Frequently asked questions
          </h1>
          <p className="text-xl sm:text-2xl text-gray-700 mb-6">
            These are the most commonly asked questions about Samsan Inc. Can&#39;t
            find what you&#39;re looking for?{" "}
            <Link href="/contact" className="text-yellow-600 hover:underline hover:underline-offset-4">
              Contact our friendly team!
            </Link>
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="w-full">
          {allFaqData.map(
            (
              faq,
              index // Use allFaqData directly
            ) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger>
                  {/* Icon based on the image */}
                  <span className="flex items-center text-lg sm:text-xl">
                    {/* Placeholder for specific icons if needed, using generic for now */}
                    <svg
                      className="h-6 w-6 text-gray-500 mr-3"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pl-9 text-base sm:text-lg">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            )
          )}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
